import angular from 'angular';

angular.module('cloudX').directive('validateVatNumber', [
  'dataCache',
  function(dataCache) {
    return {
      restrict: 'A',
      require: ['?ngModel', '^?bindErrors'],
      link: function(scope, element, attrs, ctrls) {
        var ngModel = ctrls[0];
        var bindErrors = ctrls[1];
        if (!ngModel) return; // do nothing if no ng-model

        var tenantConfiguration = dataCache.getArray('tenantConfiguration');
        if (tenantConfiguration == 2) return; // Skip vat number validation for south africa

        ngModel.$validators.vatNumber = function(modelValue, viewValue) {
          var value = modelValue || viewValue || null;
          if (value === null) return true; //Allow null and empty values
          //Replace invalid characters and spaces
          value = value.replace(/[^0-9a-zA-Z]/g, '');
          if (value.length <= 2) return false;

          if (value && value.toLowerCase().startsWith('be')) {
            return validateBelgianVatNumber(value);
          }

          return true;
        };

        if (bindErrors) {
          bindErrors.addError('vatNumber', 14006);
        }

        function validateBelgianVatNumber(value) {
          if (Number(value.slice(1, 2)) === 0) {
            return false;
          }
          const valueWithoutPrefix = value.length === 9 ? value : value.substring(2);
          const check = 97 - (Number(valueWithoutPrefix.slice(0, 8)) % 97);
          return check === Number(valueWithoutPrefix.slice(8, 10));
        }
      },
    };
  },
]);
